import { css, Global } from '@emotion/react';
import { logger } from '@ferreri/minato-logger-next';
import {
  customQueryClient,
  QueryClientProvider,
} from '@ferreri/minato-react-utils';
import { angeplus, token } from '@ferreri/prever-component-lib';
import { AppLayout } from '@ferreri/prever-component-lib/nextjs';
import { AppProps } from 'next/app';
import { Encode_Sans } from 'next/font/google';

import { SETTINGS } from '../config/settings';
import { PAGE_TITLE } from '../utils/pageTitle';

const encodeSans = Encode_Sans({
  subsets: ['latin'],
  weight: [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '700',
    '800',
    '900',
  ],
  variable: '--font-family-01',
});

logger.setBasePath(SETTINGS.public.basePath);

// This default export is required in a new `pages/_app.js` file.
export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={customQueryClient}>
      <Global
        styles={css`
          html {
            scroll-behavior: smooth;
            overflow-x: hidden;
          }

          .button_secondary_alt {
            &:hover:not(:disabled) {
              background-color: transparent !important;
            }

            > p {
              color: ${token.colors.neutralXxLight};
            }
          }
        `}
      />
      <AppLayout
        theme={angeplus}
        defaultTitle={PAGE_TITLE.defaultTitle}
        fontFamily={encodeSans.variable}
        productName="Angeplus"
        projectName="Hub"
        tmsToken={SETTINGS.public.tmsToken}
      >
        <Component {...pageProps} />
      </AppLayout>
    </QueryClientProvider>
  );
}
